import { KyInstance } from 'ky';

import { VITE_PLUGIN_SERVICE_URL } from '@/constants/env';
import { handleRequest } from '@/utils/httpUtils';

import {
  CreateOrder,
  DeletePlugin,
  GetPluginDetails,
  GetUserPlugins,
  Install,
  Order,
  Orders,
  UpdatePlugin,
  ValidateRate,
} from './types';

export interface IReqMLParcel {
  orders: Orders;
  order: Order;
  install: Install;
  validateRate: ValidateRate;
  createOrder: CreateOrder;
  getUserPlugins: GetUserPlugins;
  getPluginDetails: GetPluginDetails;
  updatePlugin: UpdatePlugin;
  deletePlugin: DeletePlugin;
}

export function reqMLParcel(http: KyInstance): IReqMLParcel {
  const route = 'api/v3/mercadolibre/parcel';
  return {
    orders: ({ page, pageSize, clientId, status, dateFrom, dateTo }) =>
      handleRequest(http, 'get', `${route}/orders`, {
        searchParams: {
          ...(page !== undefined && { page }),
          ...(pageSize !== undefined && { pageSize }),
          ...(status && { status }),
          ...(dateFrom && { dateFrom }),
          ...(dateTo && { dateTo }),
        },
        headers: { 'X-Client-ID': clientId },
      }),
    order: ({ orderId, clientId }) =>
      handleRequest(http, 'get', `${route}/orders/${orderId}`, {
        headers: { 'X-Client-ID': clientId },
      }),
    install: ({ country, clientId }) => {
      const baseUrl = new URL(`${route}/install/${country}`, VITE_PLUGIN_SERVICE_URL);
      baseUrl.searchParams.set('X-Client-ID', String(clientId));
      window.location.href = baseUrl.toString();
      return Promise.resolve();
    },
    validateRate: ({ clientId, orderId }) =>
      handleRequest(http, 'post', `${route}/orders/rate`, {
        json: { id: orderId },
        headers: { 'X-Client-ID': clientId },
      }),
    createOrder: ({ clientId, orderId }) =>
      handleRequest(http, 'post', `${route}/orders/create`, {
        json: { id: orderId },
        headers: { 'X-Client-ID': clientId },
      }),
    getUserPlugins: ({ clientId }) =>
      handleRequest(http, 'get', 'api/v3/user/plugins', {
        headers: { 'X-Client-ID': clientId },
      }),
    getPluginDetails: ({ clientId, pluginId }) =>
      handleRequest(http, 'get', `api/v3/user/plugins/${pluginId}/details`, {
        headers: { 'X-Client-ID': clientId },
      }),
    updatePlugin: ({ clientId, pluginId, data }) =>
      handleRequest(http, 'patch', `api/v3/user/plugins/${pluginId}/update`, {
        json: data,
        headers: { 'X-Client-ID': clientId },
      }),
    deletePlugin: ({ clientId, pluginId }) =>
      handleRequest(http, 'delete', `api/v3/user/plugins/${pluginId}/delete`, {
        headers: { 'X-Client-ID': clientId },
      }),
  };
}
